// Keep this import first: zod reads the setting when the first schema is built.
import '@crm/shared/zod-strict-csp';
// The app (and the stylesheets its components import) stays ahead of index.css,
// as before, so the order of the bundled CSS does not change.
import { mountMarketingApp } from './mountMarketingApp';
import './index.css';
import './i18n';
import { initializeAnalytics } from './lib/analytics';

initializeAnalytics(import.meta.env.VITE_GA_MEASUREMENT_ID);

const container = document.getElementById('root');
if (!container) {
  throw new Error('The page is missing its #root container');
}

mountMarketingApp(container);
